import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import type { CircumstanceSubsectionResponse } from '@lmc/validations'
import LastUpdateBox from 'components/carePlans/LastUpdateBox'
import { lastUpdateCarerFromUpdatedByData } from 'components/carePlans/lastUpdateCarerFromUpdatedByData'
import type { ResidentItemExtended } from 'hooks/useResident'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const CircumstancesFormCard = ({
  resident
}: {
  resident: ResidentItemExtended
}) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  return (
    <>
      <CircumstanceSubsectionFormCard
        title={t(supConstants.SOCIAL_CIRCUMSTANCES)}
        namePath={['circumstances', 'socialCircumstances', 'description']}
        subsection={resident.circumstances?.socialCircumstances}
      />
      <CircumstanceSubsectionFormCard
        title={t(supConstants.EDUCATIONAL_HISTORY)}
        namePath={['circumstances', 'educationalHistory', 'description']}
        subsection={resident.circumstances?.educationalHistory}
      />
      <CircumstanceSubsectionFormCard
        title={t(supConstants.OCCUPATIONAL_HISTORY)}
        namePath={['circumstances', 'occupationalHistory', 'description']}
        subsection={resident.circumstances?.occupationalHistory}
      />
    </>
  )
}

function CircumstanceSubsectionFormCard({
  title,
  namePath,
  subsection
}: {
  title: string
  namePath: (string | number)[]
  subsection?: CircumstanceSubsectionResponse
}) {
  return (
    <FormCard title={title}>
      <FormItem name={namePath}>
        <TextArea autoSize={{ minRows: 3 }} />
      </FormItem>
      {subsection?.updatedAt ? (
        <LastUpdateBox
          date={subsection.updatedAt}
          carer={lastUpdateCarerFromUpdatedByData(subsection.updatedByData)}
          noDateText=""
          style={{ paddingInline: 0 }}
        />
      ) : null}
    </FormCard>
  )
}
